import Formsy from 'formsy-react';
import moment from 'moment';
import globals from '../globals/communityGlobals';

Formsy.addValidationRule('isSameOrBeforeDate', (values, value, date) => {
  if (!value || !date) {
    return true;
  }

  const valueAt = moment(new Date(value));
  const dateAt = moment(date);

  return valueAt.isSameOrBefore(dateAt, 'd');
});

Formsy.addValidationRule('isBeforeDate', (values, value, date) => {
  if (!value || !date) {
    return true;
  }

  const valueAt = moment(new Date(value));
  const dateAt = moment(date);

  return valueAt.isBefore(dateAt, 'd');
});

Formsy.addValidationRule('max', (values, value, max) => value <= max);

Formsy.addValidationRule('isAfterDateFrom', (values, value) => {
  if (typeof value === 'undefined') return true;
  return values.dateFrom ? moment(value).isSameOrAfter(values.dateFrom, 'day') : true;
});

Formsy.addValidationRule('isBeforeEndDate', (values, value, date) => {
  if (!value || !date) {
    return true;
  }
  return moment(value).isSameOrBefore(moment(date));
});

Formsy.addValidationRule('isAfterDifferentField', (values, value, key) => {
  if (typeof value === 'undefined' || !values[key]) return true;
  return moment(value).isSameOrAfter(values[key], 'day');
});

Formsy.addValidationRule('isAfterDate', (values, value, date) => {
  if (!value || !date) {
    return true;
  }

  const valueAt = moment(new Date(value));
  const dateAt = moment(date);

  return valueAt.isAfter(dateAt, 'd');
});

Formsy.addValidationRule('isAfterTime', (values, value) => {
  if (!value) {
    return true;
  }
  return values.startTime ? moment(value).isSameOrAfter(values.startTime, 'minute') : true;
});

Formsy.addValidationRule('isInPast', (values, value) => {
  if (!value) {
    return true;
  }

  const nowAt = globals.now;
  const dateAt = moment(value);

  return dateAt.isSameOrBefore(nowAt, 'minute');
});

Formsy.addValidationRule('isInPresentOrFutureOrExact', (values, value, exact) => {
  if (!value) {
    return true;
  }

  const nowAt = globals.now;
  const valueAt = moment(new Date(value));
  const exactAt = moment(exact);

  return valueAt.isSame(nowAt, 'day') || valueAt.isAfter(nowAt) || valueAt.isSame(exactAt, 'day');
});

Formsy.addValidationRule('isRequired', (values, value) => {
  return value !== '' && value !== null && value !== undefined;
});
